import { isSubstringOf } from "@/shared/utils";
import type { MaybeType } from "@/shared/types";
import type { ContactsListProps } from "../types";
import { getAllNameCombinations } from "./get-person-name";

export const filterContacts = (
  contacts: ContactsListProps["contacts"],
  nameFilter: MaybeType<string>,
  titleFilter: MaybeType<string>,
) => {
  return (
    contacts.filter((person) => {
      const allPersonNameCombination = getAllNameCombinations(person);

      const matchesName = !!allPersonNameCombination.filter((fullName) => {
        return isSubstringOf({ sourceString: fullName, searchString: nameFilter ?? "" });
      }).length;

      const matchesTitle =
        !titleFilter ||
        isSubstringOf({ sourceString: person?.title ?? "", searchString: titleFilter });

      return matchesName && matchesTitle;
    }) ?? []
  );
};
